import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Transition } from 'react-transition-group';
import { transitionStyles } from './dropdownStyles';
import { strings } from 'config';

class OutlineDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValue: this.props.items[0].label,
      isOpen: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleDropdownMenu = this.handleDropdownMenu.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { filters } = nextProps;

    if(filters.headerSort.name === 'created_at'){
      if(filters.headerSort.sort === 'desc'){
        this.setState({
          selectedValue: strings.sorting.recentlyAdded
        })
      } else{
        this.setState({
          selectedValue: strings.sorting.oldestFirst
        })
      }
    }  else{
      this.setState({
        selectedValue: strings.sorting.selectOption
      });
    }
  }

  handleDropdownMenu(dropdownState) {
    this.setState({
      isOpen: dropdownState
    });
  }

  handleChange(dropdownValue, dropdownLabel) {
    this.setState(
      {
        isOpen: false,
        selectedValue: dropdownLabel
      },
      () => {
        this.props.onSortChange(dropdownValue);
      }
    );
  }

  render() {
    const { items } = this.props;

    return (
      <Dropdown
        onMouseEnter={() => this.handleDropdownMenu(true)}
        onMouseLeave={() => this.handleDropdownMenu(false)}
      >
        <DropdownButton isOpen={this.state.isOpen}>
          <Title className="title" isOpen={this.state.isOpen}>
            {this.state.selectedValue}
          </Title>
          <DropdownIcon isOpen={this.state.isOpen} />
        </DropdownButton>

        <Transition in={this.state.isOpen} timeout={100} mountOnEnter={true}>
          {state => (
            <DropdownMenu
              style={{
                ...transitionStyles[state]
              }}
            >
              <ul className="dropdown-list">
                {items.map((val, key) => (
                  <li
                    className="dropdown-list-item"
                    key={key}
                    onClick={() => this.handleChange(val.value, val.label)}
                  >
                    {val.label}
                  </li>
                ))}
              </ul>
            </DropdownMenu>
          )}
        </Transition>
      </Dropdown>
    );
  }
}

const mapStateToProps = state => {
  return {
    filters: state.filters
  };
};

export default connect(mapStateToProps)(OutlineDropdown);

const DropdownButton = styled.span`
  position: relative;
  display: inline-block;
  border-radius: 2px;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 24px;
  border: 1px solid ${props => props.theme.teals.tilicho};

  background-color: ${props => (props.isOpen ? props.theme.teals.tilicho : '#fff')};
`;

const Title = styled.span`
  color: ${props => (props.isOpen ? '#fff' : '#737b81')};
  font-size: 14px;
  cursor: pointer;
  margin-right: 16px;
`;

const DropdownIcon = styled.span`
  border-color: ${props =>
    props.isOpen ? `transparent transparent #fff` : `#00529b transparent transparent;`}
    border-width: ${props => (props.isOpen ? '0 4px 4px' : '4px 4px 0')};
  border-style: solid;
  display: inline-block;
  vertical-align: middle;
  margin-left: 6px;
`;

const Dropdown = styled.span`
  position: relative;
  min-width: 200px;
`;

const DropdownMenu = styled.div`
  padding-top: 6px;
  position: absolute;
  top: 100%;
  right: 0;
  width: 100%;
  min-width: 184px;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-4px);
  transition: all 300ms ease-in-out;

  .dropdown-list {
    background-color: ${props => props.theme.primary.raju};
    border-radius: 4px;
    box-shadow: 0 8px 40px -8px rgba(0, 0, 0, 0.15);

    .dropdown-list-item {
      display: block;
      padding: 10px 20px;
      color: #4a4a4a;
      font-size: 14px;
      transition: all 0.2s ease-in;
      line-height: 1.4;
      cursor: pointer;
      &:not(:last-child) {
        border-bottom: 1px solid #e4eaeb;
      }
      &:hover {
        color: ${props => props.theme.primary.ujyaalo};
        cursor: pointer;
      }
      > a {
        color: grey;
        white-space: nowrap;
        &.active {
          color: ${props => props.theme.primary.ujyaalo};
        }

        &:hover {
          color: ${props => props.theme.primary.ujyaalo};
          cursor: pointer;
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/dropdowns/outlineDropdown.js